export default __webpack_public_path__ + "static/media/86ae54faf5cae971595f4224e6b6d9f01636461012061.d8779018.webp";